export const connectionMode = {
    token: 'token',
    smartCard: 'smartCard',
    luxtrustMobile: 'luxtrustMobile',
    scanLuxtrust: 'scanLuxtrust',
    uSBStick: 'uSBStick',
    identityCard: 'identityCard',
};

export const appToAppScaDeviceMode = {
    token: 'token',
    luxtrustMobile: 'luxtrustMobile',
    scanLuxtrust: 'scanLuxtrust',
};

export const connectionModeToCode = {
    token: 'OrelyToken',
    smartCard: 'OrelySmartCard',
    luxtrustMobile: 'OrelyMobile',
    scanLuxtrust: 'OrelyScan',
    uSBStick: 'OrelyUSBStick',
    identityCard: 'OrelyIdCard',
};

export const modeToCode = mode => connectionModeToCode[mode];

export const connectionModeImage = {
    [connectionMode.token]: {
        src: require('../ressources/images/connection-mode/token.png'),
        srcSet: `${require('../ressources/images/connection-mode/token.png')} 1x, ${require('../ressources/images/connection-mode/token@2x.png')} 2x, ${require('../ressources/images/connection-mode/token@3x.png')} 3x`,
    },
    [connectionMode.smartCard]: {
        src: require('../ressources/images/connection-mode/smart-card.png'),
        srcSet: `${require('../ressources/images/connection-mode/smart-card.png')} 1x, ${require('../ressources/images/connection-mode/smart-card@2x.png')} 2x, ${require('../ressources/images/connection-mode/smart-card@3x.png')} 3x`,
    },
    [connectionMode.luxtrustMobile]: {
        src: require('../ressources/images/connection-mode/luxtrust-mobile.png'),
        srcSet: `${require('../ressources/images/connection-mode/luxtrust-mobile.png')} 1x, ${require('../ressources/images/connection-mode/luxtrust-mobile@2x.png')} 2x, ${require('../ressources/images/connection-mode/luxtrust-mobile@3x.png')} 3x`,
    },
    [connectionMode.scanLuxtrust]: {
        src: require('../ressources/images/connection-mode/scan-luxtrust.png'),
        srcSet: `${require('../ressources/images/connection-mode/scan-luxtrust.png')} 1x, ${require('../ressources/images/connection-mode/scan-luxtrust@2x.png')} 2x, ${require('../ressources/images/connection-mode/scan-luxtrust@3x.png')} 3x`,
    },
    [connectionMode.uSBStick]: {
        src: require('../ressources/images/connection-mode/usb.png'),
        srcSet: `${require('../ressources/images/connection-mode/usb.png')} 1x, ${require('../ressources/images/connection-mode/usb@2x.png')} 2x, ${require('../ressources/images/connection-mode/usb@3x.png')} 3x`,
    },
    [connectionMode.identityCard]: {
        src: require('../ressources/images/connection-mode/id.png'),
        srcSet: `${require('../ressources/images/connection-mode/id.png')} 1x, ${require('../ressources/images/connection-mode/id@2x.png')} 2x, ${require('../ressources/images/connection-mode/id@3x.png')} 3x`,
    },
};
